// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"936":"e5747b64a21a0905","1221":"2f8daefc5b589185","3602":"8ce93ebd508f65d8","4937":"3216e13e9c17fa97"}[chunkId] + ".css";
};